import React, { Component } from 'react';
import { connect } from 'react-redux';

import InputBase from '@material-ui/core/InputBase';

import BoardInfoAdd from './BoardInfoAdd';
import BoardInfoItem from './BoardInfoItem';
import { boardInfoService, commonService } from '../../services';
import { alertActions } from '../../modules/alert';

class BoardInfoMng extends Component {
    constructor(props) {
        super(props);
        this.state = {
            completed: 0,
            searchKeyword: '',
            boardTypeCodes: [],
            boardInfoList: [],
            gradeList: []
        }

        this.setStateBoardTypeCodes();
        this.setStateGradeList();
        this.setStateBoardInfoList();
    }

    stateRefresh = () => {
        this.setState({
            completed: 0,
            searchKeyword: '',
            boardInfoList: []
        });

        this.setStateBoardInfoList();
    }

    componentDidMount = () => {
        this.timer = setInterval(this.progress, 20);
    }

    setStateBoardTypeCodes = async () => {
        commonService.findByGroupCode('BK')
            .then(response => {
                this.setState({ boardTypeCodes: response.data })
            })
            .catch(this.handleErrors);
    }

    setStateBoardInfoList = async () => {
        boardInfoService.findAllUse()
            .then(response => {
                this.setState({ boardInfoList: response.data })
            })
            .catch(this.handleErrors);
    }

    setStateGradeList = async () => {
        commonService.findAllGradeList()
            .then(response => {
                this.setState({ gradeList: response.data })
            })
            .catch(this.handleErrors);
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    }

    progress = () => {
        const { completed } = this.state;
        this.setState({ completed: completed >= 100 ? 0 : completed + 1 });
    }

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    }

    render() {
        const filteredComponents = (boardInfoList, searchKeyword) => {
            boardInfoList = boardInfoList.filter((boardInfo) => {
                return boardInfo.boardTypeCode.indexOf(searchKeyword) > -1 || boardInfo.boardName.indexOf(searchKeyword) > -1;
            })
            return boardInfoList.map((boardInfo, i) => {
                return <BoardInfoItem key={i} stateRefresh={this.stateRefresh} boardTypeCodes={this.state.boardTypeCodes} boardInfo={boardInfo} gradeList={this.state.gradeList} />;
            })
        };

        const cellList = ["게시판명", "종류", "메뉴"];
        return (
            <React.Fragment>
                <h2 className="s-page-tit">
                    게시판 관리
                </h2>
                <div className="search-wrapper s-normal-box">
                    <InputBase
                        placeholder="게시판 검색"
                        className="input-box w100per"
                        name="searchKeyword"
                        value={this.state.searchKeyword}
                        onChange={this.handleValueChange}
                    />
                </div>
                <div className="search-button-wrapper">
                    <BoardInfoAdd stateRefresh={this.stateRefresh} boardTypeCodes={this.state.boardTypeCodes} boardTypeCode={'ST'} gradeList={this.state.gradeList} />
                </div>
                <div className="search-result-wrapper s-normal-box">
                    <table className="w100per">
                        <colgroup>
                            <col width="30%" />
                            <col width="30%" />
                            <col width="40%" />
                        </colgroup>
                        <thead className="table-head">
                            <tr>
                                {cellList.map((cell, i) => {
                                    return <th key={i}>{cell}</th>;
                                })}
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {this.state.boardInfoList &&
                                filteredComponents(this.state.boardInfoList, this.state.searchKeyword)
                            }
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        );
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(BoardInfoMng);